import ArticleListMixin from '~/mixins/ArticleListMixin'
import HeaderConfigurationMixin from '~/mixins/HeaderConfigurationMixin'
import SeoMixin from '~/mixins/SeoMixin'

export default {
  props: {
    headerConfiguration: null,
  },
  computed: {
    showHeader() {
      return this.$themeSettings.components.PageArticleList.header.enable && this.showHeaderImage
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageArticleList.breadcrumbs.index'),
          path: this.localePath({ name: 'articleList' }),
        },
      ],
      menuItems: null,
    }
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageArticleList' })
  },
  mixins: [ArticleListMixin, HeaderConfigurationMixin, SeoMixin],
}
